import { PlusIcon } from "lucide-react";
import { Link } from "react-router";

import {
  JobsEmptyState,
  JobsFiltersAndTable,
  TopbarContainer,
  TopbarTitle,
} from "@/components";
import { Button } from "@/components/ui/button";

import { useGetJobs } from "@/hooks/queries";

export const JobsPage = () => {
  const { data: jobs, status } = useGetJobs();

  if (status === "pending") {
    // TODO: Loading state.
    return null;
  } else if (status === "error") {
    // TODO: Error state.
    return null;
  }

  return (
    <div className="flex h-svh flex-col">
      <TopbarContainer className="flex items-center justify-between">
        <TopbarTitle>Jobs</TopbarTitle>
        <Button className="rounded-full" asChild>
          <Link to="create">
            <PlusIcon className="h-4 w-4" />
            Create job
          </Link>
        </Button>
      </TopbarContainer>
      {jobs.length ? (
        <JobsFiltersAndTable className="min-h-0 p-6" jobs={jobs} />
      ) : (
        <div className="flex flex-1 items-center justify-center">
          <JobsEmptyState />
        </div>
      )}
    </div>
  );
};
